
import { defineComponent, h } from 'vue';
import { message as $message, Modal } from 'ant-design-vue';
import commonApi from '@/api/common';

export default defineComponent({
  name: 'UserInfoModal',
  data() {
    return {
      visible: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 20 },
      formState: {
        name: '',
        mobile: '',
        value: 1,
      },
    };
  },
  setup() {
    const error = (str: string) => {
      $message.error(str);
    };
    const success = (str: string) => {
      $message.success(str);
    };
    return {
      error,
      success,
    };
  },
  props: ['payInfo'],
  components: {
  },
  methods: {
    showModal() {
      this.visible = true;
    },
    apply() {
      interface Data{
        result: number;
        message: string;
      }
      if (!this.formState.name) {
        this.error('请输入您的称呼');
        return;
      }
      if (!this.formState.mobile) {
        this.error('请输入联系方式');
        return;
      }
      console.log(this.formState);
      const param = {
        name: this.formState.name + (this.formState.value === 1 ? '先生' : '女士'),
        companyName: this.payInfo.name,
        mobile: this.formState.mobile,
      };
      commonApi.addVersion(param).then(async ({ result, message }: Data) => {
        if (result === 1) {
          Modal.success({
            title: '提交成功',
            okText: '好的',
            content: h('div', {}, [
              h('p', '已收到您的套餐订购申请，专属客户经理预计在1个工作日与您联系，请确保联系电话畅通'),
            ]),
          });
          this.visible = false;
        } else {
          this.error(message);
        }
      });
    },
  },
});
